import messages from 'src/components/Product/SizeChart/messages'

export const sizes = {
  womensFootwearUgg: {
    title: messages.women,
    items: [
      {
        us: 5,
        eur: 36,
      },
      {
        us: 6,
        eur: 37,
      },
      {
        us: 7,
        eur: 38,
      },
      {
        us: 8,
        eur: 39,
      },
      {
        us: 9,
        eur: 40,
      },
      {
        us: 10,
        eur: 41,
      },
      {
        us: 11,
        eur: 42,
      },
      {
        us: 12,
        eur: 43,
      },
    ],
  },
  mensFootwearUgg: {
    title: messages.men,
    items: [
      {
        us: 6,
        eur: 39,
      },
      {
        us: 6.5,
        eur: 39.5,
      },
      {
        us: 7,
        eur: 40,
      },
      {
        us: 7.5,
        eur: 40.5,
      },
      {
        us: 8,
        eur: 41,
      },
      {
        us: 8.5,
        eur: 41.5,
      },
      {
        us: 9,
        eur: 42,
      },
      {
        us: 9.5,
        eur: 42.5,
      },
      {
        us: 10,
        eur: 43,
      },
      {
        us: 10.5,
        eur: 43.5,
      },
      {
        us: 11,
        eur: 44,
      },
      {
        us: 11.5,
        eur: 44.5,
      },
      {
        us: 12,
        eur: 45,
      },
      {
        us: 13,
        eur: 46,
      },
      {
        us: 14,
        eur: 48.5,
      },
      {
        us: 15,
        eur: 49.5,
      },
      {
        us: 16,
        eur: 50.5,
      },
    ],
  },
  toddlerFootwearUgg: {
    title: messages.toddler,
    items: [
      {
        us: 6,
        eur: '22',
        cm: '13.5',
      },
      {
        us: 7,
        eur: '23.5',
        cm: 14,
      },
      {
        us: 8,
        eur: 25,
        cm: 15,
      },
      {
        us: 9,
        eur: 26,
        cm: 16,
      },
      {
        us: 10,
        eur: '27.5',
        cm: 17,
      },
      {
        us: 11,
        eur: '28.5',
        cm: 18,
      },
      {
        us: 12,
        eur: 30,
        cm: 19,
      },
    ],
  },
  infantFootwearUgg: {
    title: messages.infant,
    items: [
      {
        us: '0/1',
        eur: '16',
        cm: '9',
      },
      {
        us: '2/3',
        eur: '18',
        cm: '10.5',
      },
      {
        us: '3/4',
        eur: '18.5',
        cm: '10.5',
      },
      {
        us: '4/5',
        eur: '20.5',
        cm: '12.5',
      },
    ],
  },
  kidsFootwearUgg: {
    title: messages.kids,
    items: [
      {
        us: 13,
        eur: 31,
        cm: 20,
      },
      {
        us: 1,
        eur: '32.5',
        cm: 21,
      },
      {
        us: 2,
        eur: '33.5',
        cm: 22,
      },
      {
        us: 3,
        eur: 35,
        cm: 23,
      },
      {
        us: 4,
        eur: 36,
        cm: 24,
      },
      {
        us: 5,
        eur: 37,
        cm: 25,
      },
      {
        us: 6,
        eur: 38,
        cm: 26,
      },
    ],
  },
}
